<div class="modal-header">
  <h4 class="modal-title">Session Expired</h4>
</div>

<div class="modal-body">
  <p>Your session has expired. Please log in again to continue.</p>

  @if (form) {
    <form
      [formGroup]="form"
      [boFormOptions]="options"
      (ngSubmit)="onSubmit()"
      novalidate>
      <bo-non-field-errors />
      <app-form-field
        boFieldPath="username"
        [label]="'Email address'"
        [type]="InputType.email"
        [placeholder]="'Enter your email address'">
      </app-form-field>
      <app-password-field
        boFieldPath="password"
        [placeholder]="'Password'">
      </app-password-field>
      <div class="d-flex justify-content-end gap-3 mt-4 py-3">
        <button
          id="modalCancelBtn"
          type="button"
          class="btn btn-outline-dark"
          (click)="onCancel()"
          [disabled]="busy">
          Log out
        </button>
        <app-submit
          btnID="modalLoginSubmitBtn"
          [busy]="busy"
          label="Continue">
        </app-submit>
      </div>
    </form>
  } @else {
    <div class="py-5">
      <app-loader></app-loader>
    </div>
  }
</div>
